import { type FC } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import type {
  STATUS,
  STEPS,
} from '@/domains/proB2BServices/AddToWishlist/constants';

import { ABTests } from '../../abTests';
import { useAddToWishlist } from '../../hooks/useAddToWishlist';
import { AddToWishlistButton } from '../buttons/AddToWishlistButton';

interface Props {
  productId: number;
  onClose?: (step: STEPS, status: STATUS) => void;
}

export const AddToWishlistRender: FC<Props> = ({
  productId,
  onClose,
}: Props) => {
  const {
    modal,
    isProductInWishlistNow,
    isFetching,
    onModalOpen,
    addProductToAllWishList,
    deleteProductFromWishlist,
  } = useAddToWishlist(productId, onClose);
  const [isWishlistRevampEnabled] = useBooleanFlags([
    ABTests.WISHLIST_REVAMP_ENABLED,
  ]);

  const doInClick = () => {
    if (isWishlistRevampEnabled) {
      if (isFetching) return;

      if (!isProductInWishlistNow) {
        addProductToAllWishList();
      } else {
        deleteProductFromWishlist();
      }
    } else {
      onModalOpen();
    }
  };

  return (
    <>
      <AddToWishlistButton
        onClick={doInClick}
        isWishlistRevampEnabled={isWishlistRevampEnabled}
        isProductInWishlistNow={isProductInWishlistNow}
        isFetching={isFetching}
      />
      {modal}
    </>
  );
};
